var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hashtag",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4476 12.4798L29.1377 16.5423L31.6544 22.747L35.9659 19.4484L38.8825 23.2607L33.5726 27.3231L37.6334 37.239L33.4581 40.4334L29.3973 30.5176L25.222 33.712L29.2828 43.6278L25.1529 46.7875L21.092 36.8717L17.0075 39.9967L14.0908 36.1844L19.1738 32.2956L16.6572 26.0908L12.5726 29.2158L9.69069 25.4489L14.7737 21.5601L10.6781 11.5988L14.808 8.43913L18.9036 18.4004L23.0789 15.2059L18.9833 5.24471L23.1586 2.05029L27.2542 12.0115L31.5657 8.71294L34.4476 12.4798ZM27.4791 25.9414L24.9624 19.7367L20.7871 22.9311L23.3038 29.1359L27.4791 25.9414Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.9e7212797e87a6b82827bd8ca069b623.svg";
export { ForwardRef as ReactComponent };